module.exports = __webpack_public_path__ + "img/2.083fd322.png";